import { render } from "./DatasourceEditPage.vue?vue&type=template&id=0f1bea96"
import script from "./DatasourceEditPage.vue?vue&type=script&lang=js"
export * from "./DatasourceEditPage.vue?vue&type=script&lang=js"

import "./DatasourceEditPage.vue?vue&type=style&index=0&id=0f1bea96&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__